export default ({ initialState = {} } = {}) => {
  return {
    initialState,
  }
}
